import PropTypes from 'prop-types';
import { Alert, AlertTitle, Stack } from '@mui/material';

export default function AdminErrorState({ title, message }) {
  return (
    <Stack spacing={2}>
      <Alert severity="error" variant="outlined">
        <AlertTitle>{title}</AlertTitle>
        {message}
      </Alert>
    </Stack>
  );
}

AdminErrorState.propTypes = {
  message: PropTypes.string.isRequired,
  title: PropTypes.string,
};

AdminErrorState.defaultProps = {
  title: 'Error state pattern',
};
